export const environment = {
    production: true,
    apiEndpoint: 'https://api-pbcheckinclass.qivos.net/sso/v1'
  };
  
  